import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

function AdminLogin({ onClose }) {
  const { user, login, logout, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoggingIn(true);

    try {
      await login(email, password);
      onClose();
    } catch (err) {
      setError(err.message || 'Login mislukt');
    } finally {
      setIsLoggingIn(false);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      onClose();
    } catch (err) {
      setError(err.message || 'Uitloggen mislukt');
    }
  };

  if (loading) {
    return (
      <div className="admin-modal">
        <div className="admin-modal-content">
          <p>Laden...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-modal">
      <div className="admin-modal-content">
        <button className="admin-close-button" onClick={onClose}>
          &times;
        </button>

        <h2>Admin Login</h2>

        {user ? (
          <div className="admin-logged-in">
            <p>Ingelogd als:</p>
            <p className="admin-email">{user.email}</p>
            <button className="admin-button" onClick={handleLogout}>
              Uitloggen
            </button>
          </div>
        ) : (
          <form onSubmit={handleLogin}>
            {error && <p className="admin-error">{error}</p>}

            <div className="admin-field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>

            <div className="admin-field">
              <label htmlFor="password">Wachtwoord</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>

            <button
              type="submit"
              className="admin-button"
              disabled={isLoggingIn}
            >
              {isLoggingIn ? 'Bezig...' : 'Inloggen'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default AdminLogin;
